import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Image, ImageFit } from '@fluentui/react';

import { getChatDialogStyles } from './styles/get-chat-dialog-styles';
import AgentAvatar from '../media/agent-avatar.png';

export function ChatDialog(props) {
  const {
    onStartChat,
    onRejectChat,
    ref,
    i18n,
  } = props;

  const classes = useDefaultStyles(getChatDialogStyles);

  return (
    <div
      className={classNames(classes.container, 'chat-dialog-container')}
      ref={ref}
    >
      <div className={classes.header} />
      <div >
        <Image
          src={AgentAvatar}
          alt={i18n.getString(_TL_('Agent Avatar'))}
          className={classes.agentAvatar}
          imageFit={ImageFit.cover}
        />
        <p className={classes.subTitle}>
          {i18n.getString(_TL_('Chat with a Microsoft Advertising expert for help with account signup, campaign creation, or general support.'))}
        </p>
        <button
          className={classNames(classes.button, classes.chatNowButton, 'chat-now-button')}
          onClick={onStartChat}
        >
          {i18n.getString(_TL_('Chat now'))}
        </button>
        <button
          className={classNames(classes.button, classes.rejectButton, 'not-now-button')}
          onClick={onRejectChat}
        >
          {i18n.getString(_TL_('No thanks'))}
        </button>
      </div>
    </div>
  );
}

ChatDialog.propTypes = {
  onStartChat: PropTypes.func.isRequired,
  onRejectChat: PropTypes.func.isRequired,
  ref: PropTypes.shape({}),
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

ChatDialog.defaultProps = {
  ref: undefined,
};
